/**
 * Local-run mode flag.
 *
 * When the app is built/served by the no-AWS local stack (see RUN_LOCAL.md), this is
 * `true` and the app auto-authenticates as an Admin without Cognito. In every normal
 * (deployed) build the env var is unset, so this is `false` and behavior is unchanged.
 *
 * Mirrors the `isTestModeEnabled` pattern in services/api.ts. Kept in its own file to
 * avoid an axios.ts ⇄ api.ts circular import.
 */
export const isLocalMode = (): boolean => process.env.REACT_APP_LOCAL_MODE === 'true';
